import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'quiz-report-card',
  templateUrl: './quiz-report-card.component.html',
  styleUrls: ['../../../../theme/radio-button.scss', './quiz-report-card.component.scss']
})
export class QuizReportCardComponent implements OnInit {

  @Input() firstName = '';
  @Input() isRemoved = false;
  @Input() removedTitle = '(퀴즈가 삭제된 응답)';
  @Input() isProfileHidden: boolean | undefined;
  @Input() navUrl: string | undefined;

  constructor() { }

  ngOnInit(): void {
  }
}
